module.exports = __webpack_public_path__ + "static/media/Vigo - Multi-Cooker_Boishakh.dcaf8b58.png";